import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-informe-accion-irregular',
  templateUrl: './informe-accion-irregular.component.html',
  styleUrls: ['./informe-accion-irregular.component.scss'],
})
export class InformeAccionIrregularComponent implements OnInit {
  @Input() data: { task: any };

  constructor(private fb: FormBuilder) {}
  form: FormGroup;
  file: File | null;

  ngOnInit(): void {
    console.log(this.data);

    const { task } = this.data;
    const values = task.data ? task.data : null;
    this.form = this.fb.group({
      file: [values ? values.file : null],
    });
    this.file = values ? values.file : null;
  }
  selectFile(event: any) {
    if (event) {
      this.form.value.file = event.target.files[0];
      this.file = event.target.files[0];
    } else {
      this.file = null;
      this.form.reset();
    }
    console.log(this.form);
  }
}
